<template>
  <div
    class="m-transition"
    :class="{ 'm-transition--overflow-hidden': !allowOverflow }"
  >
    <component
      :is="transitionType"
      easing="var(--animation-timing)"
      :duration="200"
      v-bind="$attrs"
      tag="div"
    >
      <slot />
    </component>
  </div>
</template>

<script setup lang="ts">
import {
  TransitionFade,
  TransitionExpand,
  TransitionScale,
  TransitionSlide,
} from '@morev/vue-transitions'
import { PropType, computed } from 'vue'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps({
  type: {
    type: String as PropType<'fade' | 'expand' | 'scale' | 'slide'>,
    default: 'fade',
  },
  /**
   * In some situations this default settings might cause content inside to get cut off causing weird glitches.
   * If that's the case it should be better set allowOverflow to true to avoid those problems.
   */
  allowOverflow: {
    type: Boolean,
    default: false,
  },
})

const transitionType = computed(() => {
  const transitionMap = {
    fade: TransitionFade,
    expand: TransitionExpand,
    scale: TransitionScale,
    slide: TransitionSlide,
  }

  return transitionMap[props.type] || 'div'
})
</script>

<style scoped lang="scss">
.m-transition {
  &--overflow-hidden {
    overflow: hidden;
  }
}
</style>
